import { render, staticRenderFns } from "./communityIssueTitle.vue?vue&type=template&id=4f7b92e7&scoped=true&lang=pug&"
import script from "./communityIssueTitle.vue?vue&type=script&lang=js&"
export * from "./communityIssueTitle.vue?vue&type=script&lang=js&"
import style0 from "./communityIssueTitle.vue?vue&type=style&index=0&id=4f7b92e7&prod&lang=less&"
import style1 from "./communityIssueTitle.vue?vue&type=style&index=1&id=4f7b92e7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7b92e7",
  null
  
)

export default component.exports